var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherIconBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#EDEFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 28C21 28.663 20.7366 29.2989 20.2678 29.7678C19.7989 30.2366 19.163 30.5 18.5 30.5C17.837 30.5 17.2011 30.2366 16.7322 29.7678C16.2634 29.2989 16 28.663 16 28C16 27.337 16.2634 26.7011 16.7322 26.2322C17.2011 25.7634 17.837 25.5 18.5 25.5C19.163 25.5 19.7989 25.7634 20.2678 26.2322C20.7366 26.7011 21 27.337 21 28ZM37.5 25.5C36.837 25.5 36.2011 25.7634 35.7322 26.2322C35.2634 26.7011 35 27.337 35 28C35 28.663 35.2634 29.2989 35.7322 29.7678C36.2011 30.2366 36.837 30.5 37.5 30.5C38.163 30.5 38.7989 30.2366 39.2678 29.7678C39.7366 29.2989 40 28.663 40 28C40 27.337 39.7366 26.7011 39.2678 26.2322C38.7989 25.7634 38.163 25.5 37.5 25.5ZM28 25.5C27.337 25.5 26.7011 25.7634 26.2322 26.2322C25.7634 26.7011 25.5 27.337 25.5 28C25.5 28.663 25.7634 29.2989 26.2322 29.7678C26.7011 30.2366 27.337 30.5 28 30.5C28.663 30.5 29.2989 30.2366 29.7678 29.7678C30.2366 29.2989 30.5 28.663 30.5 28C30.5 27.337 30.2366 26.7011 29.7678 26.2322C29.2989 25.7634 28.663 25.5 28 25.5Z",
    fill: "#4F4FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIconBank);
export default __webpack_public_path__ + "static/media/other_icon_bank.77d19ca6308726adad66d518b12390de.svg";
export { ForwardRef as ReactComponent };